import { appStore } from "@app/store/store"
import { currencyMap, languageMap } from "@app/utils/constants"

export const setLanguage = language => {
	appStore.set(state => ({
		core: {
			...state.core,
			locale: languageMap[language],
			languageCode: language,
			currency: currencyMap[languageMap[language]],
		},
	}))
}

export const setZoneId = zoneId => {
	appStore.set(state => ({
		core: {
			...state.core,
			zoneId: zoneId,
		},
	}))
}
export const setZone = zone => {
	appStore.set(state => ({
		core: {
			...state.core,
			zone: zone,
		},
	}))
}

export const setRelation = relation => {
	appStore.set(state => ({
		core: {
			...state.core,
			relation: relation,
		},
	}))
}

export const setTransponder = transponder => {
	if (!appStore.get("core.relation")) return
	appStore.set(state => ({
		core: {
			...state.core,
			relation: {
				...state.core.relation,
				transponder,
			},
		},
	}))
}

export const setAccounts = (thermencard, employeePoints) => {
	if (!appStore.get("core.relation")) return

	let relation = appStore.get("core.relation")

	if (relation.tags?.find(e => e.tag === "Employee")) {
		relation.employeePoints = employeePoints
	}

	relation.thermencardAccount = thermencard
	appStore.set(state => ({
		core: {
			...state.core,
			relation: {
				...relation,
			},
		},
	}))
}

export const setHtgGuestData = guestData => {
	appStore.set(state => ({
		...state,
		core: {
			...state.core,
			relation: { guest: true },
			htgGuestData: guestData,
		},
	}))
}
